export type Action<T extends string, P> = {
  type: T;
  payload: P;
};

export type ActionCreator<T extends string, P> = (payload: P) => Action<T, P>;

export type ActionType<T extends (payload: any) => {type: string}> =
  ReturnType<T>;

export function createAction<T extends string, P = void>(type: T) {
  return function action(payload: P) {
    return {type, payload};
  };
}
